import { useEffect } from "react";

const TweetEmbed = ({ key, tweetId }) => {
    useEffect(() => {
        if (window.twttr) {
            window.twttr.widgets.load();
        }
    }, []);

    return (
        <blockquote
            key={key}
            className="twitter-tweet"
            data-dnt="true"
            data-theme="dark"
            data-width={'100%'}
        >
            <a href={`https://twitter.com/user/status/${tweetId}`}></a>
        </blockquote>
    );
};

export default TweetEmbed;
